import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { Especialidad, especialidadesConstants } from '../types/especialidades.types';
 
const entityConstants = especialidadesConstants
 
const fetchEspecialidades = async (): Promise<Especialidad[]> => {
	const response = await api.get(`${entityConstants.apiEndpoint}/`);
	return response?.data?.especialidades;
};
 
export const useEspecialidades = () => {
	return useQuery<Especialidad[], Error>({
		queryKey: [entityConstants.entityLabel.toLowerCase()],
		queryFn: () => fetchEspecialidades(),
		// staleTime: 5 * 60 * 1000,
		enabled: true,
	});
};